<template>
  <MarketCard class="market-insights">
    <CardHeader :eventId="eventId" />
    <div :class="[classes.content]">
      <EventNameInline
        :class="classes.inlineBanner"
        :marketId="marketId"
        :eventId="eventId"
        :useTeamNames="true"
      />
      <div :class="[classes.insightsWrapper]">
        <PromoFittedText
          :promoText="insightText"
          alignment="center"
          justifyContent="center"
        ></PromoFittedText>
      </div>

      <MarketName :class="classes.marketName" :marketId="marketId" />

      <div :class="classes.oddsButtonWrapper">
        <template v-if="relevantOption">
          <RelevantButton
            :class="[classes.oddsButton]"
            :option="relevantOption"
            :eventId="eventId"
          ></RelevantButton>
        </template>
        <template v-else>
          <Button
            :stagger="0"
            :class="[classes.oddsButton]"
            :option="firstOption"
          />
          <Button
            :stagger="2"
            :class="[classes.oddsButton]"
            :option="secondOption"
          />
        </template>
      </div>
    </div>
  </MarketCard>
</template>
<script lang="ts">
import { defineComponent, ref } from "vue";
import { createUseStyles } from "@fresh8/vue-jss/src";
import { useInsightData } from "../../../../hooks/useInsightData";

import MarketCard from "../../../styled/MarketCard.vue";
import MarketName from "../../../MarketName.vue";
import CardHeader from "../../../CardHeader.vue";
import EventNameInline from "../../../EventNameBadges.vue";
import PromoFittedText from "../../../PromoFittedText.vue";
import Button from "../Button.vue";
import RelevantButton from "../RelevantButton.vue";

const useStyles = createUseStyles({
  marketName: {
    fontSize: "12px",
    textAlign: "center"
  },
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "100%"
  },
  useLeftContent: {
    flexDirection: "row"
  },
  inlineBanner: {
    "& .competitors .banner": {
      maxWidth: "unset",
      "&.right": {
        marginLeft: "15px",
        paddingRight: "10px"
      },
      "&.left": {
        marginRight: "15px",
        paddingLeft: "10px"
      }
    },
    marginTop: "12px !important",
    "& .banner": {
      height: "34px",

      "& .badge": {
        maxWidth: "60px",
        marginTop: "10px"
      },

      "& .jersey": {
        maxWidth: "60px",
        marginTop: "10px"
      },

      "& .vs": {
        height: "34px"
      },
      "& div": {
        fontSize: "14px"
      }
    }
  },
  insightsWrapper: {
    flex: "1 1 0px",
    display: "flex",
    width: "100%",
    padding: "3px 8px",
    marginTop: "10px",
    overflow: "hidden",
    boxSizing: "border-box",
    minHeight: "0px",
    flexDirection: "column"
  },
  oddsButton: {
    flex: 1,
    height: "40px",
    "& .odds-text": {
      fontSize: "14px"
    },

    maxHeight: "40px"
  },
  oddsButtonWrapper: {
    display: "flex",
    padding: "8px",
    paddingTop: "6px",
    gap: "8px"
  },
  resize: {
    pointerEvents: "none",
    zIndex: -99
  }
});

export default defineComponent({
  components: {
    CardHeader,
    MarketCard,
    EventNameInline,
    PromoFittedText,
    Button,
    MarketName,
    RelevantButton
  },
  props: {
    eventId: {
      type: String,
      required: true
    },
    marketId: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const classes = useStyles(ref({}));
    const {
      insightText,
      firstOption,
      secondOption,
      relevantOption
    } = useInsightData(props.marketId);

    return {
      classes,
      insightText,
      firstOption,
      secondOption,
      relevantOption
    };
  }
});
</script>
